import { useKey } from '@core/logic';
import { viewer3dActions } from '@viewer3D/redux';
import { useEffect } from 'react';
import { useAppDispatch } from '@core/redux/hooks';

export const useFocusEntity = () => {
  const fPressed = useKey('f');
  const dispatch = useAppDispatch();

  useEffect(() => {
    fPressed && dispatch(viewer3dActions.focusSelectedEntity);
  }, [fPressed]);
};
